import { bl_fi_my_einvoice_notification_queue_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class EinvoiceNotificationQueueModel extends BaseContainerModel {
    bl_fi_my_einvoice_notification_queue: bl_fi_my_einvoice_notification_queue_RowClass = new bl_fi_my_einvoice_notification_queue_RowClass();
}